export default __webpack_public_path__ + "static/media/BackgroundBirds.51403e6a.jpg";